import React from "react";
import { Card } from "@/components/ui/card";
import { CheckCircle2, Mail, Calendar, Package } from "lucide-react";
import { APP_NAME } from "@/lib/constants";

export const WhiteLabelWelcomePage = () => {
  return (
    <div className="min-h-screen bg-[var(--brand-bg)] font-[Inter] flex items-center justify-center px-4 py-10" data-testid="whitelabel-welcome-page">
      <Card className="w-full max-w-xl bg-white border-[var(--brand-border)] shadow-xl overflow-hidden">
        <div className="px-8 pt-10 pb-8 text-center">
          <div
            className="mx-auto h-16 w-16 rounded-2xl flex items-center justify-center text-white mb-5"
            style={{ background: "var(--brand-primary)" }}
          >
            <CheckCircle2 className="w-9 h-9" />
          </div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[var(--brand-primary)] mb-2">{APP_NAME}</div>
          <h1 className="font-[Playfair_Display] text-3xl font-bold text-[var(--brand-ink)] mb-3" data-testid="whitelabel-welcome-title">
            Willkommen als White-Label-Partner!
          </h1>
          <p className="text-[var(--brand-muted)] leading-relaxed mb-6">
            Deine Bestellung ist erfolgreich eingegangen.<br />
            Wir prüfen den Auftrag und melden uns innerhalb von 24 Stunden persönlich bei dir.
          </p>
          <div className="bg-[var(--brand-bg)] rounded-xl p-5 text-left mb-7" data-testid="whitelabel-welcome-steps">
            <div className="text-xs font-semibold uppercase tracking-wider text-[var(--brand-primary)] mb-3">So geht es jetzt weiter</div>
            <ol className="space-y-3 text-sm text-[var(--brand-ink)]">
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-green-100 text-green-700 text-xs flex items-center justify-center"><Mail className="w-3.5 h-3.5" /></span>
                <span>Bestellbestätigung per E-Mail erhalten</span>
              </li>
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-green-100 text-green-700 text-xs flex items-center justify-center"><Calendar className="w-3.5 h-3.5" /></span>
                <span>Persönliche Kontaktaufnahme durch unser Team innerhalb von 24 Stunden</span>
              </li>
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-green-100 text-green-700 text-xs flex items-center justify-center"><Package className="w-3.5 h-3.5" /></span>
                <span>Übergabe deiner White-Label-Lizenz inkl. Quellcode</span>
              </li>
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-green-100 text-green-700 text-xs flex items-center justify-center"><CheckCircle2 className="w-3.5 h-3.5" /></span>
                <span>Einrichtung und individuelle Abstimmung (falls gebucht)</span>
              </li>
            </ol>
          </div>
          <p className="text-sm text-[var(--brand-muted)] leading-relaxed">
            Du erhältst in Kürze eine E-Mail mit allen Details. Bei Fragen erreichst du uns jederzeit unter <a href="mailto:info@femmesmarketing.com" className="text-[var(--brand-primary)] font-medium hover:underline">info@femmesmarketing.com</a>.
          </p>
          <p className="text-[11px] text-[var(--brand-muted)] mt-6">
            Vielen Dank für dein Vertrauen – dein Femmes Studio Team
          </p>
        </div>
      </Card>
    </div>
  );
};
